import React from 'react'

export default function RequestAccess({
  account, flashMessageRef, requestAccessPath, getTenantRequestAccessInfoPath, latestTenantAccessRequest, setLatestTenantAccessRequest, setLoading
}) {
  const requestAccess = _e => {
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: requestAccessPath,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setLatestTenantAccessRequest(res.latestTenantAccessRequest)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  const handleClick = _e => {
    setLoading(true)

    Rails.ajax({
      type: 'GET',
      url: getTenantRequestAccessInfoPath,
      dataType: 'json',
      success: res => {
        setLoading(false)

        window.open(`${ account.domain }/admin?dir_access_info=${ encodeURIComponent(res.accessInfo) }`, '_blank')
      },
      error: res => {
        setLoading(false)

        flashMessageRef.current.show(res.message, 'error')
        setLatestTenantAccessRequest(null)
      }
    })
  }

  const renderNonActiveTenantRequestCase = () => {
    let jsx

    if (!!latestTenantAccessRequest) {
      jsx = (
        <div className="access-requested">
          Waiting to authorize access...
        </div>
      )
    } else {
      jsx = (
        <div 
          className='btn request-access-btn flex-box items-center content-center'
          style={{ cursor: 'pointer' }}
          onClick={ requestAccess }
        >
          <i className='fa-light fa-shield-halved m-r-10' />
          <span>Request access</span>
        </div>
      )
    }

    return jsx
  }

  return (
    <>
      { (!latestTenantAccessRequest || latestTenantAccessRequest.access_type === 'request_access') &&
        <>
          { latestTenantAccessRequest && latestTenantAccessRequest.active && latestTenantAccessRequest.access_granted
            ? <>
                <div className="access-requested flex-box items-center">
                  <div 
                    className='btn m-b-5 flex-box items-center content-center'
                    style={{ cursor: 'pointer' }}
                    onClick={ handleClick }
                  >
                    <span>{ `${ account.name } admin` }</span>
                    <i className='fa-light fa-arrow-up-right-from-square' />
                  </div>

                  <div className="m-l-20">
                    { `Access Expires In ${ latestTenantAccessRequest.remaining_minutes } minutes` }
                  </div>
                </div>
              </>
            : renderNonActiveTenantRequestCase()
          }
        </>
      }
    </>
  )
}